export const KEY_CODES_WHITELIST = ['ArrowDown', 'ArrowUp', 'Enter'];
export const WHITELIST_DATA_ATTRIBUTE = 'data-whitelist-shortcuts';
export const IGNORE_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];